import { createSelector } from 'reselect'


export interface FlashSaleData {
  id: number
  name: string
  price: number
  gender: Gender | 'unisex'
  discount: number
  timeLeft: number
  startDate: string
  media: []
  tradingId: number
  products: {
    id: number
    url: string
    name: string
    brand: string
    image: string
    description: string
    price: number
    rating: number
    giftSetItems?: {
      id: number
      name: string
      brand: string
    }
  }
}

interface DataObject {
  female?: FlashSaleData
  male?: FlashSaleData
  unisex?: FlashSaleData
}

type GetDataInput = {
  dataObj: DataObject
  gender: Gender
  queryGender?: Gender
  activeGenderOnly?: boolean
}

type SelectorInput = {
  gender?: Gender
  activeGenderOnly?: boolean
}

const getActiveFlashSaleData = ({ dataObj, gender, queryGender, activeGenderOnly }: GetDataInput): Partial<FlashSaleData> => {
  let data
  // if unisex exists we show only it for any gender
  if (dataObj.unisex) {
    data = dataObj.unisex
  }
  else if (activeGenderOnly) {
    data = dataObj[gender]
  }
  else {
    const activeGender = queryGender || gender
    const oppositeGender = activeGender === 'female' ? 'male' : 'female'

    data = dataObj[activeGender] || dataObj[oppositeGender]
  }

  return data || {}
}

/**
 * Returns active flash sale data
 */
const getActiveFlashSaleDataSelector = ({ gender, activeGenderOnly }: SelectorInput = {}) => createSelector(
  (state: ReduxState): DataObject => state.view.flashSaleBundlePage.data,
  (state: ReduxState): Gender => state.models.me.gender,
  (state: ReduxState): Gender => state.routing.location.query.gender,
  (dataObj, userGender, queryGender) => getActiveFlashSaleData({
    dataObj,
    gender: gender || userGender,
    queryGender,
    activeGenderOnly,
  })
)


export {
  getActiveFlashSaleData,
  getActiveFlashSaleDataSelector,
}
